import searchUsersModule from './searchUsers/searchUsers.js';

export default angular
  .module('main.organizations.edit.components', [
    searchUsersModule,
  ])
  .name;
